<template>
  <div class="warning-img">
    <div class="warning">
      <img src="@/assets/warning_error.svg" />
    </div>
  </div>
</template>

<script>
  export default {
  }
</script>

<style lang="scss" scoped>
.warning-img {
  position: relative;
}
.warning {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  animation-delay: 0.2s;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  -webkit-animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  -webkit-animation-delay: 0.2s;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
